export default __webpack_public_path__ + "static/media/dhul.02fa4fb5.png";